export default `
... on Homepage_Homepagebuilder_rows_Content_JobDetails {
  fieldGroupName
  topContent
  bottomContent
}`;
